import { getOrElse } from 'src/util/values';

export function round(value: any, precision = 0): number {
  const multiplier = Math.pow(10, getOrElse(precision, 0));
  return Math.round(value * multiplier) / multiplier;
}

/**
 * Sums values and treats null or undefined values as 0
 */
export function sum(...values: number[]) {
  return values.reduce((sumAcc, value) => {
    return sumAcc + getOrElse(value, 0);
  }, 0);
}
